import './new.scss';

export const imagePopup = {
    init: () => {
        const $$imagesGallery = document.querySelectorAll('.js-images-gallery');
        if ($$imagesGallery.length > 0) {
            $$imagesGallery.forEach((gallery) => {
                const $$images = gallery.querySelectorAll('img');
                if ($$images.length > 0) {
                    $$images.forEach((img) => imagePopup.bindEvents(img));
                }
            });
        }
    },
    bindEvents: (img) => {
        img.classList.add('c-pointer');
        img.addEventListener('click', () => imagePopup.zoomer(img));
    },
    zoomer: (element) => {
        const zoomer = document.createElement('div');
        const img = document.createElement('img');

        zoomer.classList.add('zoomer');
        zoomer.textContent = 'Загрузка';

        img.classList.add('zoomer-img');
        img.src = element.src.split('?')[0];

        document.body.prepend(zoomer);
        img.onload = function() {
            zoomer.textContent = '';
            zoomer.append(img);
        };

        zoomer.onclick = zoomer.remove;
    },
};
